export default "__VITE_ASSET__D2mc78Qh__"